<template>
  <app-layout>
    <template #main-content>
      <main id="content" class="l-main p-work">
        <div v-if="!workStore.isValidWorks">
          <loading-page></loading-page>
        </div>
        <div v-else class="l-main__inner">
          <section class="p-work-header">
            <div
              :class="{['c-page-header-bg -'+ globalNavigationStore.selectedMenu]:true}"></div>
            <div class="p-work-header__titleBox">
              <h1 class="p-work-header__titleBox__title">
                <span :class="{['c-icon -'+ globalNavigationStore.selectedMenu]: true}">
                </span>{{getWorkSubjectName}}
              </h1>
              <button class="qid_search_menu" @click="questionLearningModal=true" v-if="accountStore.isDebug">☰</button>
            </div>
            <div class="p-work-header__cont">
              <div :class="{['p-work-header__book -'+globalNavigationStore.selectedMenu]: true}">
                <ul class="p-work-header__book-area">
                  <li class="p-work-header__book-list"
                    v-for="(item, index) in workStore.selectedWork"
                  >
                    <span class="p-work-header__book-homework" v-if="homeworkWork(item.id)">宿題</span>
                    <a :class="{['p-work-header__book-link']: true, ['select']: index === workStore.selectedWorkIndex}" href="javascript:void(0)" @click="goWork(item, index)" name="S3-1-work-subject-year-btn">
                      <img :src="item.cover" :alt="`${item.subject_field}${item.academic_year}のワーク`" width="98" v-if="item.cover">
                      <span class="c-button-white -arrow -work">
                        <span class="label">{{ item.subject_field }}
                          <span class="year" v-if="item.subject_field==='歴史' && item.academic_year===2">2・3</span>
                          <span class="year" v-else-if="item.subject_field!=='公民'">{{ item.academic_year }}</span>
                        </span>
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
              <div :class="{
                ['c-question-content -continuation -'+ globalNavigationStore.selectedMenu]:true}"
                v-if="workStore.nextQuestionSet && workStore.loading"
              >
                <span v-if="isInterruptionData(workStore.nextQuestionSet.id)" class="c-parts-bubble">学習を再開</span>
                <span v-else class="c-parts-bubble">前回のつづき</span>
                <span class="c-parts-homework -right" v-if="homeworkNextQuestionSet">宿題</span>
                <div class="c-question-content__text" @click="isInterruptionData(workStore.nextQuestionSet.id) ? interruptionModal=true : openModal()" name="S3-1-next-question-set-btn">
                  <div class="c-question-content__text__inner">
                    <div class="title">
                      <span class="c-parts-label -left">{{nextQuestionSectionLabel}}</span>
                      <markdown-view :rawText="nextQuestionSectionTitle" :souruby="accountStore.isSouruby"></markdown-view>
                    </div>
                    <div class="status">
                      <span v-if="isInterruptionData(workStore.nextQuestionSet.id)" class="c-parts-frame -small -interrupt">中断した学習</span>
                    </div>
                    <div class="block">
                      <div class="type">
                        <span v-if="nextQuestionDisplayName" :class="{'c-parts-frame':true, '-application':nextQuestionDisplayName == '応用問題'}" style="text-align: center">{{nextQuestionDisplayName[0]}}</span>
                      </div>
                      <markdown-view :rawText="nextQuestionTitle" :souruby="accountStore.isSouruby"></markdown-view>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <ul class="c-question" v-if="globalNavigationStore.selectedMenu==='rika' && isWork">
            <li class="c-question__item c-question__item--detail"
              v-for="(part, idx) in workStore.selectedWork[workStore.selectedWorkIndex].parts"
            >
              <div class="c-question-block c-question-block--rika c-question-block--detail -rika">
                <span class="c-parts-homework -right" v-if="homeworkPart(part.id)">宿題</span>
                <label :for="`chapter${part.id}`" class="c-parts-accordion-label"></label>
                <div class="c-question-block__inner">
                  <div class="c-question-block__titleBox">
                    <div class="c-question-block__box">
                      <div class="c-question-block__box__chapter">
                        <span class="c-parts-label -chapter"><span class="number">{{part.index_label}}</span></span>
                        <div class="title">
                          <markdown-view :rawText="part.title" :souruby="accountStore.isSouruby"></markdown-view>
                        </div>
                      </div>
                    </div>
                  </div>
                  <work-accordion
                    :ref="(el) => {refPart[part.id] = el}"
                    :loading="workStore.loading"
                    :part-id="part.id"
                    :chapters="part.chapters"
                    :is-open="part.id===workStore.latestPart.id"
                    :chapter-progress="workStore.chapterProgress"
                    :is-animation="isAnimation"
                    :animation-id="localAnimationId"
                    :is-souruby="accountStore.isSouruby"
                    :homework-questionsets="homeworkStore.homeworkQuestionSets"
                    @update-chapter-progress="workStore.saveChapterProgress(workStore.chapterProgress)"
                  >
                  </work-accordion>
                </div>
              </div>
            </li>
          </ul>
          <ul class="c-question" v-else>
            <li v-for="chapter in getChapters" :ref="(el) => {refChapter[chapter.id] = el}"
                :class="{'c-question__item':true,'c-question__item--clear':isAnimated(chapter.id)}" v-if="workStore.loading">
                <span class="c-parts-homework -right" v-if="homeworkChapter(chapter.id)">宿題</span>
                <router-link :to="{ name: 'chapter', params: { chapter_id: chapter.id } }" name="S3-1-part-btn">
                <div :class="{
                ['c-question-block c-question-block--link -'+ globalNavigationStore.selectedMenu]:true}">
                  <div class="c-question-block__inner">
                    <div class="c-question-block__box">
                      <div class="c-question-block__box__chapter">
                        <span class="c-parts-label -chapter"><span class="number">{{chapter.index_label}}</span></span>
                        <div class="title"><markdown-view :rawText="chapter.title" :souruby="accountStore.isSouruby"></markdown-view></div>
                      </div>
                      <div class="c-question-block__box__inner">
                        <progress-bar :ref="(el) => {refProgressBar[chapter.id] = el}"
                          :percentage="getPercentage(chapter.id)">
                        </progress-bar>
                        <textbook-page-number :page-number-range="chapter.textbook_page_range" v-if="chapter.textbook_page_range">
                          {{chapter.textbook_page_range}}
                        </textbook-page-number>
                      </div>
                    </div>
                    <star-medal
                      :number-of-star-medal="getStarMedal(chapter.id)">
                    </star-medal>
                  </div>
                </div>
              </router-link>
            </li>
          </ul>
          <popup-modal v-model="questionLearningModal" @close="questionLearningModal=false"
                       @close-layer="questionLearningModal=false" :is-help-modal="true">
            <template #main>
              <div>
                指定した小問IDまたは小問コードを学習画面で開く（カンマ区切りで複数入力可能）
              </div>
              <input type="text"
                     v-model="searchQuestionIds"
                     :class="{'qid_search_text':true,'isError': !searchQuestionByIdValidation && searchQuestionIds.length>0}">
              <p style="color: #e75821;" v-if="errorMsg">{{ errorMsg }}</p>
            </template>
            <template #footer>
              <button-blue @click="questionsSearch()" :disabled="!searchQuestionByIdValidation" :small="true">開始</button-blue>
            </template>
          </popup-modal>
          <!-- study interruption modal start -->
          <popup-modal v-model="interruptionModal" @close-layer="interruptionModal = false" @close="interruptionModal = false" name="interruption-btn">
            <template #main>
              <div class="c-popup-body__head">
                <p class="c-popup-body__head-title">
                  中断した学習を再開しますか？
                </p>
              </div>
              <div class="c-popup-body__titleBox">
                <div class="c-popup-body__titleBox-logout">
                  中断した学習の続きから再開することができます。
                </div>
              </div>
            </template>
            <template #footer>
              <div class="c-button -col2">
                <a @click="openModal()" class="c-button-white -medium -font-large" name="S3-1-start-from-beginning-btn">
                  <span class="label">最初から学習</span>
                </a>
                <button-blue @click="startInterruptDataLearning()" :medium="true" :label-normal="true" name="S3-1-resume-from-last-btn">続きから再開</button-blue>
              </div>
            </template>
          </popup-modal>
          <popup-modal v-model="questionModal" @close="closeModal()" @close-layer="closeModal()" :subject="globalNavigationStore.selectedMenu" name="close-btn">
            <template #label>
              <span class="c-parts-homework" v-if="homeworkNextQuestionSet">宿題</span>
            </template>
            <template #main>
              <div class="c-popup-body__chapter">
                <span class="c-parts-label -large">{{ nextQuestionSectionLabel }}</span>
                <div class="c-popup-body__chapter-title">
                  <markdown-view :rawText="nextQuestionSectionTitle" :souruby="accountStore.isSouruby"></markdown-view>
                </div>
              </div>
              <div class="c-popup-body__titleBox">
                <div class="c-popup-body__titleBox-title">
                  <div class="titleBlock">
                    <div class="c-parts-frame-wrapper">
                      <span v-if="nextQuestionDisplayName" :class="{'c-parts-frame -question':true, '-application':nextQuestionDisplayName == '応用問題'}">{{ nextQuestionDisplayName }}</span>
                    </div>
                    <div class="title">
                      <markdown-view :rawText="nextQuestionTitle" :souruby="accountStore.isSouruby"></markdown-view>
                    </div>
                    <div class="count">全<span class="label">{{ workStore.questions.length }}</span>問</div>
                  </div>
                </div>
                <div class="c-popup-body__titleBox-body">
                  <div class="c-parts-text-page" v-if="nextQuestionPageRange!==''">P {{ nextQuestionPageRange }}</div>
                  <div class="empty" v-else></div>
                  <div class="c-parts-last-learning -popup">
                    <p class="c-parts-last-learning__history"
                       v-if="latest_study_history.month!=='' && latest_study_history.day!==''">
                      <span class="label">前回の学習</span>
                      <span class="date">
                              <span class="num">{{ latest_study_history.month }}</span>月
                              <span class="num">{{ latest_study_history.day }}</span>日
                            </span>
                    </p>
                    <three-stars :number-of-stars="latest_study_history.stars"></three-stars>
                  </div>
                </div>
                <div class="c-parts-homework-information" v-if="homeworkInfo.length != 0">
                  <div class="c-parts-homework-information-item" v-for="homework in homeworkInfo">
                    <div class="c-parts-homework-information-label">宿題</div>
                    <div class="c-parts-homework-information-limit"><span>{{ homework.month }}</span>月<span>{{ homework.day }}</span>日({{ homework.dayOfWeek }}) <span>{{ homework.time }}</span>まで</div>
                    <div class="c-parts-homework-information-status">
                      <div class="c-parts-homework-status" :class="{[homework.statusClass]: true}">{{ homework.status }}</div>
                      <div class="c-parts-pin">{{ homework.achievement }}</div>
                      <div class="c-parts-pin -row" v-if="homework.relearning">{{ homework.relearning }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template #footer v-if="processing===false">
              <template v-if="workStore.totalNumOfQuestion>unansweredQuestion.length ||
                              workStore.latestQuestionHistories.length!==0">
                <button-blue :full="true" @click="startLearning(STUDY_TARGET_KIND.LEARN_ALL_THE_QUESTIONS, numberOfReviewTag?REVIEW_REQUIRED.QUESTION_SET_REVIEW:REVIEW_REQUIRED.NOT_REVIEW_REQUIRED)" name="start-learning-btn">全問題を学習</button-blue>
                <div class="c-button -col2">
                  <button-white :full="true" @click="solveUnansweredQuestion()" name="unanswered-question-btn"
                                :disabled="unansweredQuestion.length===0">
                    未正解の問題だけ学習<span class="remaining">({{ unansweredQuestion.length }}問)</span>
                  </button-white>
                  <button-white :full="true" @click="solvedReviewRequired()" :disabled="numberOfReviewTag===0" name="review-question-btn">
                    要復習問題だけ学習<span class="remaining">({{ numberOfReviewTag }}問)</span>
                  </button-white>
                </div>
                <div class="btnBlock__single" v-if="workStore.latestQuestionHistories.length!==0">
                  <a class="textLink" @click="showQuestionHistories(numberOfReviewTag?REVIEW_REQUIRED.QUESTION_SET_REVIEW:REVIEW_REQUIRED.NOT_REVIEW_REQUIRED)" href="javascript:void(0)" name="learning-history-btn">前回の学習結果を確認</a>
                </div>
              </template>
              <template v-else>
                <button-blue :full="true" @click="startLearning(STUDY_TARGET_KIND.LEARN_ALL_THE_QUESTIONS, numberOfReviewTag?REVIEW_REQUIRED.QUESTION_SET_REVIEW:REVIEW_REQUIRED.NOT_REVIEW_REQUIRED)" name="start-learning-btn">始める</button-blue>
              </template>
            </template>
          </popup-modal>
        </div>
      </main>
    </template>
  </app-layout>
</template>

<script setup lang="ts">
  import {ref, computed, onMounted, onUnmounted, watch, nextTick} from 'vue';
  import {useRoute, useRouter} from "vue-router";
  import {event} from "vue-gtag";
  import {SUBJECTFIELD_MAP, SUBJECT_MAP, VALID_SUBJECT_NAME} from "@/consts/subject";
  import {SUBJECTFIELD_ID_IMAGE_MAP} from "@/consts/images";
  import {STUDY_TARGET_KIND, REVIEW_REQUIRED} from "@/consts/study";
  import AudioPlayer from '@/consts/sounds';
  import remove_markdown from "@/util/remove_markdown";
  import {IChapterProgress, IWork} from "@/consts/interfaces";
  import HomeworkInfo from "@/util/homework-info";
  import { isEnvCaptureGoogleAnalyticsEvents } from "@/util/env"
  import {findSectionByQuestionSetId,findSectionByChapterId} from "@/util/extract-section-data"
  import { useAccountStore } from '@/store/student/account_store';
  import { useWorkStore } from '@/store/student/work_store';
  import { useGlobalNavigationStore } from '@/store/student/global_navigation_store';
  import { useHomeworkStore } from '@/store/student/homework_store';
  import { saveInitialStudyBreakData } from '@/util/study_break_data';
  import local_time from '@/util/datetime';
  import { getLatestBreakDataVersion } from '@/consts/break_data_version'
  import { createLatestQuestionHistories } from '@/util/create-lastest-qhistories';

  const audioPlayer = AudioPlayer.getInstance()
  const refPart = ref([])
  const refChapter = ref([])
  const refProgressBar = ref([])
  const route = useRoute()
  const router = useRouter()
  const accountStore = useAccountStore()
  const workStore = useWorkStore()
  const globalNavigationStore = useGlobalNavigationStore()
  const homeworkStore = useHomeworkStore()

  const questionModal = ref(false)
  const interruptionModal = ref(false)
  const isAnimation = ref(false)
  const newChapterProgress = ref<{[id: string] : IChapterProgress}>({})
  const processing = ref(false)
  const latest_study_history = ref({
      stars: 0,
      month: "" as string | number,
      day: "" as string | number
  })
  const questionLearningModal = ref(false)
  const searchQuestionIds = ref("")
  const errorMsg = ref("")
  const isQCode = ref(false)
  const localAnimationId = ref(0)
  const refresh_timer = ref(null)
  const learningStartPage = {
    name: route.name,
    path: route.path,
    params: route.params,
  }
  onMounted(async() => {
    // check valid params
    if(isSubjectName.value && VALID_SUBJECT_NAME.indexOf(route.params.work_id as string) === -1){
      router.replace({name: "pageNotFound"})
      return
    }
    // NFR-4440 chapter画面が再ロードする時ナビゲーションメニューで該当する教科が選択されたままを維持するためwork画面からsessionに教科値を保存
    sessionStorage.setItem("selectedMenu", route.params.work_id as string)
    localAnimationId.value = workStore.animationId
    // 内側のスクロールがあるS3-7,8,9画面から戻る時は外側(body)スクロール禁止するクラスを削除する（ipadの不具合）
    let body_tag = document.getElementsByTagName('body')[0]
    body_tag.classList.remove("unscrollable")

    workStore.saveNextQuestionSet(null)
    workStore.saveMission(null)
    if(workStore.learningStartPage && workStore.learningStartPage.name=='work' && !workStore.isPrevQuestionHistory){
      isAnimation.value = true
    }

    workStore.saveIsPrevQuestionHistory(false)
    homeworkStore.saveIsHomework(false)
    globalNavigationStore.saveSelectedMenu(route.params.work_id as string)
    // NFR-4440 ワーク/ワークAPIの値が取得したら画面レンダリングで必要な処理を行う。
    if(workStore.isValidWorks){
      renderingData()
    }
     // track browser back button
    window.addEventListener('popstate', browserBackHandler);
    horizontalScroll()
    if(isAnimation.value && workStore.isSearchQuestionById===false){
      bookListScrollIntoView()
      const progress = workStore.chapterProgress[localAnimationId.value]
      if(workStore.nextQuestionSet){
        const sectionData =  findSectionByChapterId(workStore.works, workStore.nextQuestionSet.chapter_id)
        workStore.saveSections(sectionData)
      }
      if(progress && progress.progress == 100 && progress.number_of_starmedal == 3){
        isAnimation.value = false
        return
      }
      let work_id: number = workStore.selectedWork[workStore.selectedWorkIndex].id
      newChapterProgress.value = await workStore.fetchChapterProgress({"work_id": work_id, "animation": true})
      if(globalNavigationStore.selectedMenu == "rika"){
        let part_id: number = 0
        for(const part of workStore.selectedWork[workStore.selectedWorkIndex].parts){
          for(const chapter of part.chapters){
            if(chapter.id==localAnimationId.value){
              part_id = part.id
              break
            }
          }
          if(part_id>0){
            break
          }
        }
        await refPart.value[part_id].showAnimation(newChapterProgress.value[localAnimationId.value])
      }else{
        // NFR-4738 TypeError cannot read properties of undefined (reading 'scrollIntoView')
        if(refChapter.value[localAnimationId.value]){
          refChapter.value[localAnimationId.value].scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"})
          await showAnimation(newChapterProgress.value[localAnimationId.value])
        }
      }
      setTimeout(() => {
        // reset isAnimation for switch work
        isAnimation.value = false
      }, 1000)
    }else{
      // for reset search question by ID
      workStore.saveIsSearchQuestionById(false)
    }
  })
  const isSubjectName = computed(() => {
    return !/^\d+$/.test(route.params.work_id as string)
  })
  async function showAnimation(chapterProgress){
    return new Promise((resolve, reject) => {
      if(!!chapterProgress){
        refProgressBar.value[localAnimationId.value]?.animate(chapterProgress.progress).then(()=>{
          workStore.saveChapterProgress(newChapterProgress.value)
          if(chapterProgress.number_of_starmedal==3){
            refresh_timer.value = setTimeout(()=>{
              refChapter.value[localAnimationId.value]?.classList.add("is-clear")
            }, 200)
          }else {
            refChapter.value[localAnimationId.value]?.classList.remove("c-question__item--clear")
          }
          resolve(true)
        })
      }else{
        refChapter.value[localAnimationId.value]?.classList.remove("c-question__item--clear")
        resolve(true)
      }
    })
  }
  function isAnimated(chapter_id){
    return isAnimation.value && localAnimationId.value == chapter_id;
  }
  const isWork = computed(() => {
    return workStore.selectedWork.length > 0 && !!workStore.selectedWork[workStore.selectedWorkIndex]
  })
  const workTitle = computed(() => {
    if(isWork.value){
      return workStore.selectedWork[workStore.selectedWorkIndex].name
    }
  })
  const getWorkSubjectName = computed(() => {
    if(isWork.value){
      return workStore.selectedWork[workStore.selectedWorkIndex].subject.name
    }
  })
  const nextQuestionSection = computed(() => {
    if (workStore.nextQuestionSet) {
      return workStore.sections.filter(item => {
        return workStore.nextQuestionSet.section_id == item.id
      })
    }
  })
  const nextQuestionSectionTitle = computed(() => {
    const section = nextQuestionSection.value
    if(section && section.length > 0){
      return section[0].title
    }
    return ""
  })
  const nextQuestionSectionLabel = computed(() => {
    const section = nextQuestionSection.value
    if(section && section.length > 0){
      return section[0].sort_order
    }
    return ""
  })
  const nextQuestionPageRange = computed(() => {
    if(workStore.nextQuestionSet){
      return workStore.nextQuestionSet.textbook_page_range
    }
  })
  const nextQuestionTitle = computed(() => {
    if(workStore.nextQuestionSet){
      return workStore.nextQuestionSet.title
    }
  })
  const nextQuestionDisplayName = computed(() => {
    if(workStore.nextQuestionSet){
      return workStore.nextQuestionSet.question_set_label.display_name
    }
  })
  const subjectImage = computed(() => {
    if(isWork.value){
      return SUBJECTFIELD_ID_IMAGE_MAP[SUBJECTFIELD_MAP[workStore.subField]]
    }
  })
  const getChapters = computed(() => {
    let chapters = []
    if (isWork.value) {
      for (const part of workStore.selectedWork[workStore.selectedWorkIndex].parts) {
        chapters = chapters.concat(part.chapters)
      }
    }
    return chapters
  })
  function isInterruptionData(id: number):boolean {
    return workStore.study_break_data[workStore.selectedWorkId]?.break_data?.question_set_id === id
  }
  function getPercentage(chapter_id) {
    if(workStore.chapterProgress[chapter_id]){
      return workStore.chapterProgress[chapter_id].progress
    }
    else{
      return null
    }
  }
  function getStarMedal(chapter_id){
    if(workStore.chapterProgress[chapter_id]){
      return workStore.chapterProgress[chapter_id].number_of_starmedal
    }else{
      return 0
    }
  }
  const unansweredQuestion = computed(() => {
    let questions: any = []
    for(let question of workStore.questions){
      if(!workStore.answeredQuestionIds.includes(question.id)){
        questions.push(question)
      }
    }
    return questions
  })
  const numberOfReviewTag = computed(() => {
    return workStore.reviewTags.length
  })
  // workが宿題対象かチェック
  function homeworkWork(work_id){
    return homeworkStore.homeworkQuestionSets.some(h => work_id == h.work_id)
  }
  // partが宿題対象かチェック
  function homeworkPart(part_id){
    return homeworkStore.homeworkQuestionSets.some(h => part_id == h.part_id)
  }
  // chapterが宿題対象かチェック
  function homeworkChapter(chapter_id){
    return homeworkStore.homeworkQuestionSets.some(h => chapter_id == h.chapter_id)
  }
  // 「前回のつづき」が宿題対象かチェック
  const homeworkNextQuestionSet = computed(() => {
    if(workStore.nextQuestionSet){
      return homeworkStore.homeworkQuestionSets.some(h => workStore.nextQuestionSet.id == h.question_set_id)
    }
  })
  // 出題単位に表示する宿題情報取得
  const homeworkInfo = computed(() => {
    if(workStore.nextQuestionSet){
      const hwInfo = new HomeworkInfo(workStore.nextQuestionSet.id, homeworkStore.homeworkQuestionSets)
      return hwInfo.info;
    }
    return [];
  })
  const searchQuestionByIdValidation = computed(() => {
    // validate search question_ids format i.e 1-252,2,3,4-253, 595, 5, 8c85d8e08ce044f5ab55adc6e85ee81f
    if(!searchQuestionIds.value){
      errorMsg.value = ""
    }
    isQCode.value = false
    let isValid = true
    let q_code_regex = /[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}|[0-9a-f]{12}4[0-9a-f]{19}/
    let q_id_regex = /^[0-9]+([-][0-9]+)?(,[ ]?[0-9]+([-][0-9]+)?)*?$/
    for (let q of searchQuestionIds.value.split(",")){
      if(q.match(q_id_regex)){ // question_idをチェックする
        isValid = true
      }else if(q.match(q_code_regex) && q.length === 32){ // question_codeをチェックする
        isQCode.value = true
        isValid = true
      }else{
        isValid = false
      }
    }
    return isValid
  })
  async function questionsSearch() {
    errorMsg.value = ""
    let question_ids: Array<string> = []
    for (let qId of searchQuestionIds.value.split(",")) {
      let question_id = qId.split("-")
      question_ids.push(question_id[question_id.length - 1])
    }
    try {
      let result, questions, question_ids_insert_order, difference;
      if(isQCode.value){ // question_codeの場合
        result = await workStore.fetchSearchQuestions({ "question_codes": question_ids })
        questions = result.data.questions.filter(item => item.subject_field === workStore.subjectField)
        questions.sort((a,b)=> question_ids.indexOf(a.code.toString()) - question_ids.indexOf(b.code.toString()))
        question_ids_insert_order = questions.map(item => item.code.toString())
        difference = question_ids.filter(x => question_ids_insert_order.indexOf(x) === -1)
      }else{ // question_idの場合
        result = await workStore.fetchSearchQuestions({ "question_ids": question_ids })
        questions = result.data.questions.filter(item => item.subject_field === workStore.subjectField)
        // ユーザーが入力した順にソートする
        questions.sort((a,b)=> question_ids.indexOf(a.id.toString()) - question_ids.indexOf(b.id.toString()))
        // 入力した順のidを取る
        question_ids_insert_order = questions.map(item => item.id.toString())
        // 入力したqidと取得したquestionsのqidの差分取得(不正なqid取得するため) : NFR-3455対応
        difference = question_ids.filter(x => question_ids_insert_order.indexOf(x) === -1)
      }
      
      if (questions.length > 0 && !difference.length) {
        let question_ids: Array<number> = questions.map(({ id }) => id)
        let question_set_ids: Array<number> = questions.map(({ question_set_id }) => question_set_id)
        workStore.saveIsPrevQuestionHistory(true)
        workStore.saveIsLearningPage(true)
        workStore.saveIsLearningMode(true)
        workStore.saveQuestionIds(question_ids)
        workStore.saveQuestions(questions)
        workStore.saveQIdx(0)
        workStore.saveLearningStartPage(learningStartPage)
        let questionCorrectWrongList = question_ids.map((item) => {
          return {
            result: null,
            progress: 0
          }
        })
        workStore.saveQuestionCorrectWrongList(questionCorrectWrongList)
        workStore.saveIsSearchQuestionById(true)
        workStore.initializeAnswer()
        const sectionData =  findSectionByQuestionSetId(workStore.works,question_set_ids)
        workStore.saveSections(sectionData)
        if(accountStore.isSoundEnabled){audioPlayer.startSound().play()}
        searchQuestionIds.value = ""
        questionLearningModal.value = false
        router.push({ name: 'question' })
      } else {
        if(isQCode.value){
          errorMsg.value = `無効な小問コードが含まれています。(コード: ${difference.join(",")})`
        }else{
          errorMsg.value = `無効な小問IDが含まれています。(id: ${difference.join(",")})`
        }
      }
    }
    catch (e) {
      if (e.response.data && e.response.data.error && e.response.data.error.message) {
        errorMsg.value = "有効なワークではありません。"
      } else {
        errorMsg.value = "内部サーバーエラーが発生しました。"
      }
    }
  }
  function bookListScrollIntoView() {
    nextTick(() => {
      let book_list_div: HTMLElement = document.querySelector(".p-work-header__book");
      if(book_list_div){  // check for undefined object
        let scrollOffset: number = book_list_div.scrollWidth / workStore.selectedWork.length
        if(scrollOffset){
          book_list_div.scrollLeft = scrollOffset * (workStore.selectedWorkIndex - 1)
        }
      }
    })
  }
  function horizontalScroll() {
    // NFR-3782 対応
    let book_list_div: HTMLElement = document.querySelector(".p-work-header__book");
    if (book_list_div) {
      book_list_div.addEventListener('wheel', bookListScroll, {passive: true})
    }
  }
  function bookListScroll(event: WheelEvent) {
    let book_list_div: HTMLElement = document.querySelector(".p-work-header__book");
    let [x, y] = [event.deltaX, event.deltaY];
    let magnitude;
    event.preventDefault();
    if (x === 0) { // マウスホイール
      if (y === 0) { // タッチパッドでもx値が0の場合が来る。その時y値を見てleft値を変更する
        magnitude = x
      } else {
        magnitude = y < 0 ? -30 : 30;
      }
    } else { // タッチパッド
      magnitude = x
    }
    book_list_div.scrollBy({
      left: magnitude
    });
  }
  async function goWork(work, index){
    workStore.saveLoading(false)
    workStore.saveNextQuestionSet(null)
    document.title = remove_markdown(work.name)
    workStore.saveSelectedWorkIndex(index)
    workStore.saveSubField(work.subject_field)
    workStore.saveSelectedWorkSession({"index": index, "subject_name": SUBJECT_MAP[work.subject.name]})
    // get latest part_id for show part broadly
    if(globalNavigationStore.selectedMenu == "rika"){
      await workStore.fetchLatestPart({work_id: work.id}).catch(() => {});
    }
    await workStore.fetchChapterProgress({"work_id": work.id}).catch(() => {});
    await findInterruptNextQuestionSet(work)
    if(workStore.nextQuestionSet){
      const sectionData =  findSectionByChapterId(workStore.works, workStore.nextQuestionSet.chapter_id)
      workStore.saveSections(sectionData)
    }
    workStore.saveLoading(true)
    bookListScrollIntoView()
  }
  async function startInterruptDataLearning() {
    await openModal(false)
    startLearning(STUDY_TARGET_KIND.LEARN_ALL_THE_QUESTIONS, REVIEW_REQUIRED.NOT_REVIEW_REQUIRED, true)
  }
  async function openModal(isQuestionModal=true){
    interruptionModal.value = false
    if(accountStore.isSoundEnabled && isQuestionModal){audioPlayer.startSound().play()}
    latest_study_history.value = {
        stars: 0,
        month: "",
        day: ""
    }
    processing.value = true
    workStore.saveIsReviewQuestion(false)
    workStore.saveIsMissionQuestion(false)
    workStore.saveIsUnanswered(false)
    workStore.saveIsPrevQuestionHistory(false)
    workStore.saveIsWronglyAnswered(false)
    questionModal.value = isQuestionModal
    const nextQuestionSet = workStore.nextQuestionSet; // ローカル変数に設定
    if(nextQuestionSet){ // NFR-5255 nextQuestonSetがある場合のみ下の処理を実行する。
      await workStore.fetchQuestions({"question_set_id": nextQuestionSet.id})
      workStore.saveTotalNumOfQuestion(workStore.questionIds.length)
      const sectionData =  findSectionByChapterId(workStore.works, nextQuestionSet.chapter_id)
      workStore.saveSections(sectionData)
      await workStore.fetchReviewTag({"question_set_id": nextQuestionSet.id})
      await workStore.fetchLatestQuestionHistories({"question_set_id": nextQuestionSet.id})
      let section_progress = await workStore.fetchSectionProgress({
          "chapter_id": nextQuestionSet.chapter_id,
          "animation": true
      })
      if(section_progress[nextQuestionSet.section_id]){
        const question_set: Array<any> = section_progress[nextQuestionSet.section_id].question_sets.filter(item=>{
          return item.id == nextQuestionSet.id
        })
        if(question_set.length>0 && question_set[0].latest_question_set_history){
          latest_study_history.value.stars = question_set[0].latest_question_set_history.progress_stars
          latest_study_history.value.month = parseInt(question_set[0].latest_question_set_history.last_studied_at.slice(5,7))
          latest_study_history.value.day = parseInt(question_set[0].latest_question_set_history.last_studied_at.slice(8,10))
        }
      }
      // for getting unanswered question
      await workStore.fetchQuestionSetProgress({"question_set_ids": [nextQuestionSet.id]})
      processing.value = false
    }else{
      processing.value = false; // nextQuestionSetがない場合もprocessingをfalseにする
    }
  }
  function closeModal(){
    if(accountStore.isSoundEnabled){audioPlayer.closeSound().play()}
    questionModal.value = false
  }
  function solveUnansweredQuestion(){
    workStore.saveIsUnanswered(true)
    workStore.saveIsWronglyAnswered(false)
    workStore.saveQuestions(unansweredQuestion.value)
    let question_ids:Array<number> = []
    unansweredQuestion.value.forEach(question => question_ids.push(question.id))
    workStore.saveQuestionIds(question_ids)
    startLearning(STUDY_TARGET_KIND.LEARN_UNANSWERED_QUESTIONS)
  }
  function solvedReviewRequired(){
    if(workStore.reviewTags.length>0){
      workStore.saveIsReviewQuestion(true)
      let questions: Array<any> = []
      let question_ids: Array<number> = []
      workStore.reviewTags.forEach(review => {
        questions.push(review.question)
        question_ids.push(review.question.id)
      })
      workStore.saveQuestions(questions)
      workStore.saveQuestionIds(question_ids)
      workStore.saveTotalNumOfQuestion(question_ids.length)
      startLearning(STUDY_TARGET_KIND.LEARN_REVIEW_REQUIRED_QUESTIONS, REVIEW_REQUIRED.QUESTION_SET_REVIEW)
    }
  }
  function startLearning(study_target_kind:number=STUDY_TARGET_KIND.LEARN_ALL_THE_QUESTIONS, review_kind:number=REVIEW_REQUIRED.NOT_REVIEW_REQUIRED, isInterrupt=false){
    workStore.saveQIdx(0)
    if(workStore.questionIds.length>0){
      workStore.saveIsLearningPage(true)
      workStore.saveIsLearningMode(true)
      workStore.saveLearningStartPage(learningStartPage)
      if(accountStore.isSoundEnabled){audioPlayer.startSound().play()}
      workStore.saveSelectedQuestionSet({[workStore.nextQuestionSet.id]:workStore.nextQuestionSet})
      let questionCorrectWrongList = workStore.questionIds.map((item) => {
        return {
          result: null,
          progress: 0
        }
      })
      workStore.fetchQuestionProgress({question_ids: workStore.questionIds})
      workStore.initializeAnswer()
      workStore.saveAnimationId(workStore.nextQuestionSet.chapter_id)
      if(isEnvCaptureGoogleAnalyticsEvents()){
        event('start_study', {
          'subject_field': workStore.selectedWork[workStore.selectedWorkIndex].subject_field,
          'study_target_kind': study_target_kind,
          'review_kind': review_kind,
          'work_id': workStore.selectedWork[workStore.selectedWorkIndex]?.id,
          'target_question_count': questionCorrectWrongList.length
        })
      }
      // NFR-5118: start last interruption
      if(isInterrupt){
        // NFR-5868: getting the interruption data
        const break_data = workStore.study_break_data[workStore.selectedWorkId]?.break_data
        workStore.saveIsWronglyAnswered(true)
        questionCorrectWrongList = break_data?.correct_wrong_list
        // NFR-5868: ensure to save initialAnswer as an array
        workStore.saveInitializeAnswer(break_data?.saved_answers || [])
        // NFR-5118: getting interruption question index
        const current_question_index = break_data?.interrupt_index
        // NFR-5118: getting the last interrupt path
        const interrupt_path = break_data?.interrupt_path
        workStore.saveQIdx(current_question_index)
        const created_at = break_data?.data_created_at
        const updated_at = local_time()
        study_target_kind = break_data?.study_target
        // NFR-5679 initialAnswerの長さがquestionsの長さと一致しない場合には該当するquestionsを取得して再保存処理を行う。
        if(workStore.initialAnswer.length !== workStore.questions.length){
            const initial_question_ids = workStore.initialAnswer.map(answer=> answer.question_id)
            const filtered_questions = workStore.questions.filter(question => initial_question_ids.includes(question.id))
            workStore.saveQuestionIds(initial_question_ids)
            workStore.saveQuestions(filtered_questions)
        }
        // NFR-5116: initilize study break data when resume learning
        saveInitialStudyBreakData(workStore, workStore.nextQuestionSet.id, questionCorrectWrongList, created_at, updated_at, null, getLatestBreakDataVersion(), study_target_kind, current_question_index)
        workStore.saveQuestionCorrectWrongList(questionCorrectWrongList)
        // 中断して再開する時が未正解問題を解くの場合
        if(study_target_kind && study_target_kind === STUDY_TARGET_KIND.LEARN_UNANSWERED_QUESTIONS){
          // NFR-5679 study_targetが未正解問題を解くの場合はis_unanswered stateをtrueに変更する（S3-10結果画面の数字が正しく表示するため）
          workStore.saveIsUnanswered(true)
          // NFR-5442 中断して再開する時、正答済みの解答欄はDBに保存しないようにする。（S3-10の誤答のみ解くと同じ仕様にする）
          workStore.initialAnswer.forEach(answer => {
            answer.quiz_histories.forEach(quiz => {
                quiz.is_first_correct_answer = quiz.is_correct_answer;
            });
          });
        }
        router.push({name:`${interrupt_path}`})
      } else {
        // NFR-5116: initilize study break data
        saveInitialStudyBreakData(workStore, workStore.nextQuestionSet.id, questionCorrectWrongList, local_time(), null, null, getLatestBreakDataVersion(), study_target_kind)
        workStore.saveQuestionCorrectWrongList(questionCorrectWrongList)
        router.push({name:'question'})
      }
    }
  }
  function showQuestionHistories(review_kind: number){
    if(accountStore.isSoundEnabled){audioPlayer.startSound().play()}
    workStore.initializeAnswer()
    workStore.saveIsDisabledButton(false)
    workStore.saveIsLearningPage(true)
    workStore.saveIsLearningMode(true)
    workStore.saveQIdx(0)
    workStore.saveIsPrevQuestionHistory(true)
    workStore.saveLearningStartPage(learningStartPage)
    workStore.saveSelectedQuestionSet({[workStore.nextQuestionSet.id]:workStore.nextQuestionSet})
    const questionCorrectWrongList = createLatestQuestionHistories();
    workStore.saveAnimationId(workStore.nextQuestionSet.chapter_id)
    if(isEnvCaptureGoogleAnalyticsEvents()){
      event('start_study', {
        'subject_field': workStore.selectedWork[workStore.selectedWorkIndex].subject_field,
        'study_target_kind': STUDY_TARGET_KIND.CHECK_RESULT_PREVIOUS_STUDY,
        'review_kind': review_kind,
        'work_id': workStore.selectedWork[workStore.selectedWorkIndex]?.id,
        'target_question_count': questionCorrectWrongList.length
      })
    }
    // reset router transit time for history check
    workStore.saveTransitTime(0)
    router.push({name:'answer'})
  }
  function browserBackHandler(event:any) {
    // prevent browser back button action for learning state
    if(event.currentTarget.location.pathname == "/student/answer"){
      window.history.forward()
    }
    else{
      window.location.reload()
    }
  }
  async function renderingData(){
    let work: Array<IWork> = []
    
    if(isSubjectName.value){
      work = workStore.workBySubName[route.params.work_id as string]
    } else {
      const work_id: number = parseInt(route.params.work_id as string)
      work = workStore.works.filter(item => item.id == work_id)
    }
    if(work.length>0){
      let prev_work_index = work.findIndex(item => item.select === true)
      let current_work_index: number
      if(prev_work_index >= 0){
        // find initial selection from session
        current_work_index = prev_work_index
      }
      else {
        // fetch latest learning work_id
        let latest_learning = await workStore.fetchLatestLearningWorkId({"subject_name": work[0].subject.name})
        // find in initial selection from latest learning
        prev_work_index = work.findIndex(item => item.id === latest_learning.data.work_id)
        if(prev_work_index >= 0){
          current_work_index = prev_work_index
        } else {
          // find initial selection by classroom.academic_year
          prev_work_index = work.findIndex(item => item.academic_year === accountStore.academicYear)
          if(prev_work_index >= 0) {
            current_work_index = prev_work_index
          } else{
            // find initial selection by max textbook.academic_year
            current_work_index = work.reduce((accumulator, current, index) => {
              return current.academic_year > work[accumulator].academic_year ? index : accumulator;
            }, 0)
          }
        }
      }
      // await this.saveSelectedMenu(SUBJECT_MAP[work[current_work_index].subject.name])
      workStore.saveSubField(work[current_work_index].subject_field)
      workStore.saveSelectedWorkIndex(current_work_index)
      workStore.saveSelectedWork(work)
      workStore.saveSelectedWorkSession({"index": current_work_index, "subject_name": SUBJECT_MAP[work[current_work_index].subject.name]})
      document.title = remove_markdown(work[current_work_index].name)
      await findInterruptNextQuestionSet(work[current_work_index])
      // get latest part_id for show part broadly
      if(globalNavigationStore.selectedMenu == "rika"){
        await workStore.fetchLatestPart({work_id: work[current_work_index].id}).catch(() => {});
      }
      await workStore.fetchChapterProgress({"work_id": work[current_work_index].id}).catch(() => {});
      if (workStore.nextQuestionSet) {
        const sectionData =  findSectionByChapterId(workStore.works, workStore.nextQuestionSet.chapter_id)
        workStore.saveSections(sectionData)
      }
      workStore.saveLoading(true)
      await homeworkStore.fetchHomeworkQuestionSet()
    }else{
      router.replace({name:'pageNotFound'})
    }
    bookListScrollIntoView()
    workStore.saveLearningStartPage(null)
    workStore.saveAnimationId(0)
    // 「前回のつづき」の問題を解いて「次の問題へ」を押した場合
    if(route.query.p === "openModal" && workStore.nextQuestionSet){
      await openModal()
    }
  }
  // NFR-5118: extract question_set from work
  function extractInterruptQuestionSet(data: any, question_set_id: number, chapter_id = null) {
    let result = []; // 結果を格納する配列を初期化
    data.some(item => { // NFR-5665 dataの各itemに対して処理を行う
        if (item.chapters) { // itemにchaptersが存在する場合
            // 再帰的にchaptersを処理し、結果を結合
            result = result.concat(extractInterruptQuestionSet(item.chapters, question_set_id, null));
        }
        if (item.sections) { // itemにsectionsが存在する場合
            // 再帰的にsectionsを処理し、結果を結合
            result = result.concat(extractInterruptQuestionSet(item.sections, question_set_id, item.id));
        }
        if (item.question_sets) { // itemにquestion_setsが存在する場合
            // question_set_idと一致するquestion_setをフィルタリング
            const foundSets = item.question_sets.filter(question_set => question_set.id === question_set_id);
            if (foundSets.length > 0) { // 一致するquestion_setが見つかった場合
                // foundSetsをresultに結合し、chapter_idとsection_idを追加
                result = result.concat(
                    foundSets.map(question_set => ({
                        ...question_set, // 元のquestion_setのプロパティを展開
                        chapter_id: chapter_id, // chapter_idを追加
                        section_id: item.id, // section_idを追加
                    }))
                );
                return true; // 一致が見つかったのでループを抜ける
            }
        }
        return false; // 一致が見つからなかったのでループを続ける
    });
    return result; // 結果を返す
  }
  // NFR-5118: find interruption next QuestionSet
  async function findInterruptNextQuestionSet(work:IWork) {
    const question_set_id = workStore.study_break_data[work.id]?.break_data?.question_set_id
    if(question_set_id !== undefined){
      const result = extractInterruptQuestionSet(work.parts, question_set_id)
      if(result.length){
        // save the interruption questionSet as a nextQuestionSet
        return workStore.saveNextQuestionSet(result[0])
      }
    }
    return await workStore.fetchNextQuestionSet({"work_id": work.id}).catch(() => {});
  }
  watch(
    () => workStore.works,
    (newVal) => {
      // NFR-4440 ワーク/ワークAPIの値を監視してある場合のみ画面レンダリングで必要な処理を行う。
      if(newVal){
        renderingData()
      }
    }
  )
  onUnmounted(() => {
    // NFR-5175 学習モード以外のみprogressをリセットする。
    if(!workStore.isLearningMode){
      // NFR-5175 workページが破棄されたらprogress stateを初期化する。
      workStore.resetChapterProgress()
    }
    window.removeEventListener('popstate', browserBackHandler);
    clearTimeout(refresh_timer.value)
  })
</script>